module.exports = __webpack_public_path__ + "static/media/referrals-xl.436bf1f4.png";